import { ExportDataItem } from "../store/slices/MRSlice"

export const API_BASE_URL = "{{BASE_URL}}"

export const VERSION = "V1.0.16"

// export const EMAIL_REGEX = /^\w+([+.-]?\w+)@\w+([.-]?\w+)(.\w\w+)+$/
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const [CREDIT, CTR, MAP_CHECKIN, CHECKING_PRO, AI_CREDITS] = ["credit", "ctr", "map-checkin", "checkin-pro", "ai-credit"];


export const [SCHEDULE_CALL, CTR_ONBOARDING, MAP_CHECKINGS_ONBOARDING] = [
    "https://link.mapranking.com/widget/booking/MUGJhTsLQibn3xc4OlVR",
    "https://link.mapranking.com/widget/booking/iXkFJG5DCuTcIMVkRfyJ",
    "https://link.mapranking.com/widget/booking/Q9teAqQ4PxdJziEYaJeq"
]

export const CALL_TO_ACTIONS = [
    { label: "None", value: "none" },
    { label: "Learn more", value: "Learn more" },
    { label: "Book", value: "Book" },
    { label: "Call", value: "Call now" },
    { label: "Order Online", value: "Order online" },
    { label: "Buy", value: "Buy" },
    { label: "Sign up", value: "Sign up" }
]


export const COOKIES_KEYS = {
    secretKey: "cookie_calendar_budget",  // Store securely, don't hard-code it
    email: "cookie_email",
    password: "cookie_password",
    language: "cookie_language",
    theme: "cookie_theme",
    refreshToken: "refreshToken",
}

export const LANGUAGES: { language: string, code: string }[] = ([
    { language: "English", code: "en" },
    { language: "Espanol", code: "es" },
    { language: "Français", code: "fr" },
])

export const NIGHT_MODE_MAP_STYLES = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
        featureType: "administrative.locality",
        elementType: "labels.text.fill",
        stylers: [{ color: "#d59563" }],
    },
    {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ color: "#d59563" }],
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ color: "#263c3f" }],
    },
    {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [{ color: "#6b9a76" }],
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#38414e" }],
    },
    {
        featureType: "road",
        elementType: "geometry.stroke",
        stylers: [{ color: "#212a37" }],
    },
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ color: "#9ca5b3" }],
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#746855" }],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#1f2835" }],
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ color: "#f3d19c" }],
    },
    {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#2f3948" }],
    },
    {
        featureType: "transit.station",
        elementType: "labels.text.fill",
        stylers: [{ color: "#d59563" }],
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#17263c" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#515c6d" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#17263c" }],
    },
];

export const LIGHT_MODE_MAP_STYLES = [
    {
        "featureType": "all",
        "elementType": "all",
        "stylers": [
            {
                "lightness": 20
            },
        ]
    }
];

export const TIME_RANGE_OPTIONS = [
    { key: '1w', label: '1 week' },
    { key: '1m', label: '1 month' },
    { key: '3m', label: '3 months' },
    { key: '6m', label: '6 months' },
    { key: '1y', label: '1 year' },
    { key: 'all', label: 'All time' },
];

export const EXPORT_CSV_DATA = (exportData: ExportDataItem[]) => {
    if (!exportData || exportData.length === 0) {
        return [];
    }

    return exportData.map((item: ExportDataItem, index: number) => ({
        "Index Number": index,
        "Business Name": item.business_name || "",
        "Keyword": item.keyword || "",
        "Last Scan Date": item["Last Scan Date"] || "",
        "Avg Rank": item["Avg. rank"] || "",
        "Longitude": item.longitude || "",
        "Latitude": item.latitude || "",
        "Address": item.address || "",
        "Crawl Frequency (days)": item["Crawl frequency (days)"] || 0,
        "Pin Count": item.pin_count || 0,
        "Spacing": item.spacing || 0,
        "Good Pins": item.good_pins || 0,
        "Medium Pins": item.medium_pins || 0,
        "Bad Pins": item.bad_pins || 0,
        "Not Ranking Pins": item.not_ranking_pins || 0,
        "Market Share": item.marketShare || "",
        "Reviews": item.reviews || 0,
        "Rating": item.rating || 0,
        "Google URL": item.google_url || "",
        "Place ID": item["Place id"] || "",
        "Website URL": item.website_url || ""
    }));
};

export const EXPORT_CSV_HEADER = [
    { label: "Index Number", key: "Index Number" },
    { label: "Business Name", key: "Business Name" },
    { label: "Keyword", key: "Keyword" },
    { label: "Last Scan Date", key: "Last Scan Date" },
    { label: "Avg Rank", key: "Avg Rank" },
    { label: "Lng", key: "Longitude" },
    { label: "Lat", key: "Latitude" },
    { label: "Address", key: "Address" },
    { label: "Refresh Frequency (days)", key: "Crawl Frequency (days)" },
    { label: "Pin Count", key: "Pin Count" },
    { label: "Miles", key: "Spacing" },
    { label: "Good Pins", key: "Good Pins" },
    { label: "Mid Pins", key: "Medium Pins" },
    { label: "Bad Pins", key: "Bad Pins" },
    { label: "Not Ranking Pins", key: "Not Ranking Pins" },
    { label: "Reviews", key: "Reviews" },
    { label: "Rating", key: "Rating" },
    // { label: "Google URL", key: "Google URL" },
    { label: "Place ID", key: "Place ID" },
    { label: "Business URL", key: "Website URL" }
];

export const AGENCY_EXPORT_CSV_DATA = (exportData: any) => {
    const data = Array.isArray(exportData) ? exportData : (exportData?.data || []);
    if (data.length === 0) {
        return [];
    }

    return data.map((item: any, index: number) => ({

        "Index": index + 1,
        "Date": item.createdAt ? new Date(item.createdAt).toLocaleDateString() : "-",
        "Widget Name": item.widget_id?.widget_name || "-",
        "Business Name": item.business_name || "-",
        "Keyword": item.keyword || "-",
        "First Name": item.first_name || "-",
        "Last Name": item.last_name || "-",
        "Email": item.email || "-",
        "Phone": item.phone_number || "-",
        "Website": item.website || "-",
        "Status": item.report_state || "-",
        "Reason": item.skip_reason || "-",
        "Grid Multiplier": item.scan_config?.grid_multiplier || "-",
        "Radius": item.scan_config?.radius || "-",
        "Report URL": item.public_report_url || "-",
        "Report Email Sent": item.report_email_sent || "-",
    }));
};

export const AGENCY_EXPORT_CSV_HEADER = [
    { label: "Index", key: "Index" },
    { label: "Date", key: "Date" },
    { label: "Widget Name", key: "Widget Name" },
    { label: "Business Name", key: "Business Name" },
    { label: "Keyword", key: "Keyword" },
    { label: "First Name", key: "First Name" },
    { label: "Last Name", key: "Last Name" },
    { label: "Email", key: "Email" },
    { label: "Phone", key: "Phone" },
    { label: "Website", key: "Website" },
    { label: "Status", key: "Status" },
    { label: "Reason", key: "Reason" },
    { label: "Grid Multiplier", key: "Grid Multiplier" },
    { label: "Radius", key: "Radius" },
    { label: "Report URL", key: "Report URL" },
    { label: "Report Email Sent", key: "Report Email Sent" },
];

export const formattedDate = (dateV: any) =>
    dateV.toLocaleString("en-US", {
        day: "numeric",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    }).replace(/,|:|\s/g, "-").replace(/-+/g, "-")

export const dummyData = [
    {
        "_id": "6893059d40e7f57587ddaa6d",
        "place_id": "ChIJ7XYBGZ1ewokRCKXcLmlVdMY",
        "keyword": "pizza",
        "name": "Joe's Restaurant",
        "credits": 56,
        "added_by": "6892ff0b40e7f57587dda5b8",
        "formatted_address": "66-11 Forest Ave, Ridgewood, NY 11385, United States",
        "type": "rectangle",
        "timeZone": "Asia/Calcutta",
        "nextUpdateTime": "2025-09-07T03:30:00.000Z",
        "grid_multiplier": 5,
        "radius": 9,
        "disabledPins": [],
        "public": false,
        "refresh_frequency": "monthly",
        "refresh_hour": 9,
        "report_pending": false,
        "report_state": "completed",
        "repeat_every": 1,
        "location": {
            "type": "Point",
            "coordinates": [
                -73.9032742,
                40.707426
            ]
        },
        "history": [

            {
                "report_id": "augustreport001",
                "score": {
                    "avg": "18.0",
                    "high": 1,
                    "mid": 0,
                    "low": 20
                },
                "status": "completed",
                "skipReason": "",
                "_id": "augustreport001",
                "timestamp": "2025-08-15T10:12:00.000Z"
            },
            {
                "report_id": "septemberreport002",
                "score": {
                    "avg": "12.5",
                    "high": 0,
                    "mid": 2,
                    "low": 22
                },
                "status": "completed",
                "skipReason": "",
                "_id": "septemberreport002",
                "timestamp": "2025-09-28T14:45:00.000Z"
            },
            {
                "report_id": "689305af40e7f57587ddaa80",
                "score": {
                    "avg": "20.0",
                    "high": 0,
                    "mid": 0,
                    "low": 25
                },
                "status": "completed",
                "skipReason": "",
                "_id": "689305af40e7f57587ddaa82",
                "timestamp": "2025-08-06T07:35:11.712Z"
            },
        ],
        "created_at": "2025-08-06T07:34:53.299Z",
        "__v": 0,
        "report_id": "689305af40e7f57587ddaa80",
        "score": {
            "avg": 20,
            "high": 0,
            "mid": 0,
            "low": 25
        }
    }
]

export const STRIPED_PLACEHOLDER_IMAGE =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj48ZGVmcz48cGF0dGVybiBpZD0icCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBwYXR0ZXJuVHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMjQiIGZpbGw9IiNkYmU1ZWUiLz48cmVjdCB4PSIxMiIgd2lkdGg9IjEyIiBoZWlnaHQ9IjI0IiBmaWxsPSIjZWRmM2Y4Ii8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI3ApIi8+PC9zdmc=";

export const dummyMapData = [
    {
        review: {
            rating: "4",
            reviewer: "John Doe",
            comment: "This is a dummy review comment.",
            reply: "Thank you for your feedback!",
            platformName: "Google",
            reviewLink: "https://www.google.com/review/dummy",
            googleReviewId: "dummy12345"
        },
        _id: "dummyId12345",
        moment: {
            location: {
                type: "Point",
                coordinates: [-122.4194, 37.7749] // Example: San Francisco
            },
            _id: "dummyMomentId123",
            address: "123 Dummy Street, San Francisco, CA, 94103, US",
            clientName: "Dummy Client",
            categories: ["Dummy Services"]
        },
        business_id: {
            _id: "dummyBusinessId123",
            business_name: "Dummy Business Inc.",
            categories: [
                { name: "Dummy Services", _id: "catDummy1" },
                { name: "Fake Category", _id: "catDummy2" }
            ],
            logo: "https://via.placeholder.com/150",
            logo_placement: "center",
            id: "dummyBusinessId123"
        },
        employee: "dummyEmployeeId123",
        platform: "website_widget",
        enabled: true,
        title: "Dummy Title",
        description: "This is a dummy description for testing purposes.",
        callToAction: "Visit Now",
        callToActionUrl: "https://www.dummyurl.com",
        images: [
            {
                url: STRIPED_PLACEHOLDER_IMAGE,
                description: "Dummy placeholder image",
                _id: "dummyImageId123"
            }
        ],
        reviewType: "none",
        scheduled: false,
        scheduledAt: "2025-11-04T07:28:42.958Z",
        status: "published",
        approvalStatus: null,
        failureReason: "",
        postedAt: null,
        platformPostId: "",
        platformPostUrl: "",
        all_widgets: true,
        widgets: [],
        createdAt: "2025-11-04T07:28:42.960Z",
        updatedAt: "2025-11-10T06:08:34.695Z",
        __v: 0,
        reject_reason: ""
    }
];
